// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"87f7377c","453":"e7a1c9cd"}[chunkId] + ".chunk.js";
};